module.exports = __webpack_public_path__ + "89ba3cb588fcfd95da5fed96c0b70555.svg";